var searchTime = null;
var lastSearchString = null;
var searchPath= $('#search-box-input').parents('form').attr('action');

$('#search-box-input').on('paste', function (e) {
    // console.log('trigger: ', 'paste', e.keyCode, $(this).val());
    search($(this));
})
.on('keyup', function (e) {
    if (e.keyCode != 40 && e.keyCode != 13) {
        // console.log('trigger: ', 'keyup', e.keyCode, $(this).val());
        search($(this));
    }
});

function search(searchItem) {
    var suggestionsBox = $('#live-search-results');
    var key = searchItem.val();
    searchTime = Date.now();
    var searchTimeCurrent = searchTime;
    // console.log(searchTimeCurrent.toString(), searchTime.toString());

    setTimeout(function () {

        // console.log('      ', searchTimeCurrent.toString(), searchTime.toString());

        if (searchTimeCurrent.toString() === searchTime.toString()) {

            if (key && (key.length > 3 || key.toLowerCase() == 'gse' || key == '360' || key.toLowerCase() == 'eye')) {

                lastSearchString = key;

                var request = new XMLHttpRequest();
                request.open('GET', searchPath + '?live=1&string=' + key, true);
                request.onload = function () {
                    if (request.status >= 200 && request.status < 400) {
                        if (lastSearchString == key) {
                            // console.log();
                            suggestionsBox.html(request.response);
                        }
                    }
                };
                request.send();

            } else {
                suggestionsBox.html('');
            }
        }
    }, 250);
}